import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ConfigurationNavigationStateService {
  readonly search = signal('');
  readonly selectedSection = signal('Colaboración');
}
